import { GroupByDimension } from '../../services/comparisonDashboardService';

export const COMPARISON_GROUP_BY_OPTIONS: { value: GroupByDimension; label: string }[] = [
  { value: 'product', label: 'Product' },
  { value: 'customer', label: 'Customer' },
  { value: 'brand', label: 'Brand' },
  { value: 'category', label: 'Category' },
  { value: 'sales_rep', label: 'Sales Rep' },
  { value: 'territory', label: 'Territory' },
];

/** Executive Breakdown opens on Category so the first fetch is a short list, not every product×customer. */
export const EXECUTIVE_BREAKDOWN_DEFAULT_GROUP_BY: GroupByDimension = 'category';

export const COMPARISON_SECONDARY_LABEL: Record<GroupByDimension, string> = {
  product: 'Customer',
  customer: 'Product',
  brand: 'Customer',
  category: 'Product',
  sales_rep: 'Product',
  territory: 'Product',
};

export const COMPARISON_METRIC_COLUMNS = [
  { key: 'revenue', label: 'Revenue', format: 'currency' as const },
  { key: 'qty', label: 'Qty', format: 'number' as const },
  { key: 'avg_sale', label: 'Avg Sale', format: 'currency' as const },
  { key: 'min_sale', label: 'Min Sale', format: 'currency' as const },
  { key: 'max_sale', label: 'Max Sale', format: 'currency' as const },
  { key: 'avg_price', label: 'Avg Price', format: 'currency' as const },
  { key: 'min_price', label: 'Min Price', format: 'currency' as const },
  { key: 'max_price', label: 'Max Price', format: 'currency' as const },
] as const;

export function formatComparisonMetricValue(
  value: number | null | undefined,
  format: string
): string {
  if (value == null || Number.isNaN(Number(value))) {
    return format === 'currency' ? '$0.00' : '0';
  }
  if (format === 'currency') {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
